    import React from 'react';
    import './estilos.css';

    import "bootstrap/dist/css/bootstrap.min.css"



    const inicio = () => {




        return (
            <div className="body">
                <div className="imagen">
                <a className="redondo btn" href="https://api.whatsapp.com/send?phone=584141908300" target="_blank" style={{position: 'fixed', top: '3%', left: 1270}}><img src="http://assets.stickpng.com/images/5ae21cc526c97415d3213554.png"
                className="redondo" style={{position: 'fixed', top: '3%', left: 1270}}></img></a>
                <br/>
                    
                    <h1 align="center"><b> Servicios:</b></h1>
                    <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    height: 3,
                                    width: 300,
                                    borderColor : '#000000'}} /> 
                                
                    <section className="container flex ml-5">
                    <section>
                <div className="columna">
                    <h2 align="center">Citologías Y PAF</h2>
                    <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    width: 300,
                                    height: 1,
                                    borderColor : '#000000'}}/>
                
                    <li> Estudiamos la célula y su estructura a nivel microscópico con el objetivo de valorar cambios en la morfología de la misma para el diagnóstico de alguna patología presente</li>
                    
                </div> 
                </section>    
                <section>     
                <div className="columna mr-3">
                    
                    <h2 align="center">Biopsias</h2>
                    <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    width: 200,
                                    height: 1,
                                    borderColor : '#000000'}}/>
                
                    <li>Una biopsia es un procedimiento diagnóstico que consiste en la extracción de una muestra total o parcial de tejido para ser examinada al microscopio 
                                          
                    </li>
                   
                </div> 
                </section>  
                </section>
                
                <br/>
                <br/>
                <br/>

               

                <section className="container flex ml-5">
                  
                <div className="columna  ">
                    <h2 align="center">Inmunohistoquímica</h2>
                    <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    width: 350,
                                    height: 1,
                                    borderColor : '#000000'}}/>
                

                    <li>Realizamos dicha técnica basada en una reacción antígeno-anticuerpo, con el objetivo de detectar, ampliar y hacer visible un antígeno específico para su posterior descripcion</li>
                </div>  
                <div className="columna ml-5">
                    <h2 align="center">Coloraciones Especiales</h2>
                    <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    width: 400,
                                    height: 1,
                                    borderColor : '#000000'}}/>
                

                    <li> Son un tipo de tinciones para distintos componentes de un tejido a través del uso de colorantes y reacciones quimicas, con el fin de observar cambios en los distintos componentes del tejido</li>
                </div>
                </section>
                
                <br/>
                <br/>
                <br/>
                <br/>
                
            
            
            
                
            
                
            <section className="ubicacion" align="center">
                    <section className="envios">
                        <h1><b>Recepcion de muestras</b></h1> 
                        <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    height: 3,
                                    width: 500,
                                    borderColor : '#000000'}}/> 
                                    <br/>
                        <h4> Trabajamos con recepción de muestras enviadas desde todo el territorio nacional a traves de las agencias de envios</h4>
                    <br/>
                   
                        </section>
                    <br/>
                    <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            <section align="center">
            <h1><b>Ubicación</b></h1> 
                        <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    height: 3,
                                    width: 300,
                                    borderColor : '#000000'}}/> 
                                    <br/>
                
                                    <br/>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31425.203087000555!2d-69.34723375718634!3d10.086761363891942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x73c2bfb5fc27c2ff!2sHospitalito!5e0!3m2!1ses!2sve!4v1615931421667!5m2!1ses!2sve"
                    
                    className="ubicacion"
                    style={{
                        width:"1000px",
                        height:"150px",
                        style:"border:0;",
                        allowfullscreen:"",
                        loading:"lazy"}}> 
                        </iframe>
                        <h5 align="center">Salud Premium Club Hospitalito C.A. Carrera 21 esquina calle 15. Casa n° 14-95. Zona Centro. 
        Barquisimeto, Estado Lara.</h5>
        <hr/>
        <section className="mt-1 mb-5">
            <div align="center">
                <h4>Desarrollado por Gexperts</h4>
                <hr style={{  color: '#000000',
                                    backgroundColor: '#000000',
                                    height: 1,
                                    width: 300,
                                    borderColor : '#000000'}}/>
            </div> 
        </section>
                        <br/>
                        </section>
                        </section>
                        </div>
                        
    </div>

        );
    }
    
    export default inicio;